const photoLocations = [
  { name: "CVS Pharmacy", link: "https://www.cvs.com/store-locator/", note: "Walk-in passport photos at most Delaware locations" },
  { name: "Walgreens", link: "https://www.walgreens.com/storelocator", note: "Appointment recommended, walk-ins accepted statewide" },
  { name: "UPS Store", link: "https://www.theupsstore.com/tools/find-a-store", note: "Also handles overnight shipping of documents" },
  { name: "FedEx Office", link: "https://www.fedex.com/en-us/shipping/store/locator.html", note: "Photos + shipping in one stop" },
  { name: "Walmart", link: "https://www.walmart.com/store-finder", note: "Photo center at select Delaware locations" },
];

const airports = [
  { code: "ILG", name: "Wilmington Airport (New Castle)", address: "141 N DuPont Hwy, New Castle, DE 19720", link: "https://www.flyilg.com/" },
  { code: "PHL", name: "Philadelphia International Airport", address: "8000 Essington Ave, Philadelphia, PA 19153", link: "https://www.phl.org/" },
  { code: "BWI", name: "Baltimore-Washington International", address: "7062 Elm Rd, Baltimore, MD 21240", link: "https://www.bwiairport.com/" },
  { code: "EWR", name: "Newark Liberty International", address: "3 Brewster Rd, Newark, NJ 07114", link: "https://www.newarkairport.com/" },
];

const shippingOptions = [
  { name: "FedEx", locator: "https://www.fedex.com/en-us/shipping/store/locator.html", note: "Priority Overnight for document submission" },
  { name: "UPS", locator: "https://www.theupsstore.com/tools/find-a-store", note: "Next Day Air Early AM available" },
  { name: "USPS", locator: "https://tools.usps.com/find-location.htm", note: "Priority Mail Express with tracking" },
];

export default function DelawareStateResources() {
  return (
    <section id="resources" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">State Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Delaware Passport Resources
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Everything Delaware travelers need — photo locations, shipping options, airports, vital records, and the closest regional passport agencies serving the First State.
          </p>
        </div>

        {/* Passport Photo Locations */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-camera-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Passport Photo Locations</h3>
              <p className="text-gray-400 text-xs">Find a location near you in Delaware</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {photoLocations.map((loc, i) => (
              <a
                key={i}
                href={loc.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-[#1A365D] text-sm">{loc.name}</h4>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{loc.note}</p>
              </a>
            ))}
          </div>
          <div className="mt-4 bg-[#FEF9E7] border border-[#F6C344]/20 rounded-lg p-4 flex items-start gap-3">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-[#F6C344] text-lg"></i>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">
              <strong className="text-[#1A365D]">Photo requirements:</strong> 2×2 inches, white or off-white background, taken within the last 6 months. A bad photo is the #1 reason passport applications get delayed. Always double-check before submitting — Fast Passport Center reviews your photos before submission.
            </p>
          </div>
        </div>

        {/* Airports */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-flight-takeoff-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Nearby Airports for Delaware Travelers</h3>
              <p className="text-gray-400 text-xs">Verify passport validity before booking international flights</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
            {airports.map((ap, i) => (
              <a
                key={i}
                href={ap.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="bg-[#1A365D] text-white text-xs font-bold px-2 py-0.5 rounded">{ap.code}</span>
                    <h4 className="font-semibold text-[#1A365D] text-sm">{ap.name}</h4>
                  </div>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{ap.address}</p>
              </a>
            ))}
          </div>
        </div>

        {/* Nearest Passport Agencies */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-building-2-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Philadelphia Passport Agency</h3>
                <p className="text-gray-400 text-xs">Nearest agency — approx. 25–40 min from Wilmington</p>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">600 Arch St Suite 4200<br/>Philadelphia, PA 19106</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">877-487-2778</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Mon–Fri 8:00 AM – 3:00 PM (appointment required)</p>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <p className="text-gray-500 text-xs leading-relaxed">
                The Philadelphia Passport Agency is the primary emergency option for Delaware residents. Appointments are typically booked 2+ weeks out. Fast Passport Center couriers bypass the wait by hand-delivering directly to State Department processing facilities.
              </p>
            </div>
          </div>

          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                <i className="ri-building-2-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Washington D.C. Passport Agency</h3>
                <p className="text-gray-400 text-xs">Alternative agency — approx. 90–120 min from Wilmington</p>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">600 19th St NW<br/>Washington, DC 20036</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">877-487-2778</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Mon–Fri 8:00 AM – 3:00 PM (appointment required)</p>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-200">
              <p className="text-gray-500 text-xs leading-relaxed">
                The Washington DC Passport Agency is an alternative for Sussex County and southern Delaware residents who may be closer to DC than Philadelphia. Like all regional agencies, appointments fill quickly and walk-ins are not accepted.
              </p>
            </div>
          </div>
        </div>

        {/* Delaware Vital Records */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-file-list-3-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Delaware Vital Records</h3>
              <p className="text-gray-400 text-xs">Birth certificates for first-time passport applications</p>
            </div>
          </div>
          <div className="bg-[#F7F8FA] rounded-lg p-7 border border-gray-100">
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              First-time passport applicants need a certified birth certificate. Delaware birth records are issued by the Delaware Division of Public Health — Office of Vital Statistics.
            </p>
            <a
              href="https://www.dhss.delaware.gov/dph/vs/vitalstats.html"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Order Delaware Birth Certificate <i className="ri-external-link-line"></i>
            </a>
            <div className="mt-4 pt-4 border-t border-gray-200 space-y-2">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">Standard processing: 4–6 weeks. Expedited available for an additional fee.</p>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-money-dollar-circle-line text-gray-400 text-sm"></i>
                </div>
                <p className="text-gray-600 text-sm">$25 per certified copy — one copy required per passport application.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Shipping Options */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
              <i className="ri-truck-line text-[#1A365D] text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-[#1A365D] text-lg">Shipping &amp; Document Delivery</h3>
              <p className="text-gray-400 text-xs">Overnight options for getting documents to the processing center fast</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {shippingOptions.map((ship, i) => (
              <a
                key={i}
                href={ship.locator}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group bg-[#F7F8FA] rounded-lg p-5 border border-gray-100 hover:border-[#F6C344]/40 transition-all duration-200"
              >
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-[#1A365D] text-sm">{ship.name}</h4>
                  <div className="w-6 h-6 flex items-center justify-center text-gray-400 group-hover:text-[#F6C344] transition-colors">
                    <i className="ri-external-link-line text-sm"></i>
                  </div>
                </div>
                <p className="text-gray-500 text-xs leading-relaxed">{ship.note}</p>
              </a>
            ))}
          </div>
        </div>

        {/* Bottom tip */}
        <div className="bg-[#0F2240] rounded-lg p-6 md:p-8 text-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 mx-auto mb-4">
            <i className="ri-lightbulb-line text-[#F6C344] text-xl"></i>
          </div>
          <h4 className="font-bold text-white text-base mb-2">Pro Tip for Delaware Travelers</h4>
          <p className="text-white/70 text-sm max-w-2xl mx-auto leading-relaxed">
            Delaware&apos;s prime Mid-Atlantic location means most residents can reach both Philadelphia International (PHL) and Baltimore-Washington International (BWI) in under 90 minutes. Corporate travelers from Wilmington&apos;s banking and financial corridor frequently need expedited passports on short notice. The peak passport months are April through August. If you are planning summer travel to Europe or family cruises out of Baltimore, start your expedited application at least 6 weeks before departure — even with courier service. Delaware residents near the New Castle County border also have the option of Philadelphia Passport Agency as their nearest emergency facility.
          </p>
        </div>
      </div>
    </section>
  );
}